import {
  GeckoComponentDataFrame,
  GeckoComponentDataset,
  GeckoPublishingState,
} from 'types'

/**
 * Select the preferred CDF for a unit (optionally scoped to an inspection).
 * Preference order:
 * 1) Non-raw publishing state
 * 2) Sort using GeckoComponentDataFrame.GetDefaultSort(componentDatasets)
 * Falls back to raw if no eligible non-raw exists.
 */
export function selectPreferredCdf(params: {
  unitId: string
  inspectionId?: string
  cdfs: ReadonlyArray<GeckoComponentDataFrame>
  componentDatasets: ReadonlyArray<GeckoComponentDataset>
}): GeckoComponentDataFrame | undefined {
  const { unitId, inspectionId, cdfs, componentDatasets } = params

  const isNonRaw = (cdf: GeckoComponentDataFrame) => {
    const cdsDirect = componentDatasets.find(
      (ds) => ds.id === cdf.tags['component-dataset']
    )
    const cdsFallback = componentDatasets.find(
      (ds) =>
        ds.tags.inspection === cdf.tags.inspection &&
        ds.tags.component === cdf.tags.component
    )
    const cds = cdsDirect ?? cdsFallback
    if (!cds) return true
    return cds.data.publishing_state.id !== GeckoPublishingState.Raw.id
  }

  const candidates = cdfs
    .filter((cdf) => cdf.tags.unit === unitId)
    .filter((cdf) =>
      inspectionId ? cdf.tags.inspection === inspectionId : true
    )

  const nonRaw = candidates
    .filter((cdf) => isNonRaw(cdf))
    .sort(GeckoComponentDataFrame.GetDefaultSort(componentDatasets))

  if (nonRaw.length > 0) return nonRaw[0]
  const any = candidates.sort(
    GeckoComponentDataFrame.GetDefaultSort(componentDatasets)
  )
  return any[0]
}
